import { createAction, props } from '@ngrx/store';

export const textWithButtonsFormUpdated = createAction(
  '[TextWithButtons] Form Updated',
  props<{
    valid: boolean;
    elementVisual: any;
    dataTosaveVisual: any;
    buttonShow: any;
    docpath: string;
    index: number;
    action: any;
  }>()
);
